export const CATEGORIES = [
  { slug: "carte-pokemon", name: "Carte & Pokémon", short: "Carte", hex: "#E11D48",
    badge: "bg-rose-50 text-rose-700 border-rose-200", accent: "border-l-rose-500", dot: "bg-rose-500",
    description: "Carte Pokémon, sportive e TCG: novità, valori e guide per collezionisti." },
  { slug: "orologi", name: "Orologi da Collezione", short: "Orologi", hex: "#059669",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200", accent: "border-l-emerald-500", dot: "bg-emerald-500",
    description: "Orologi vintage e moderni: quotazioni indicative, referenze e mercato." },
  { slug: "auto", name: "Auto d'Epoca", short: "Auto", hex: "#EA580C",
    badge: "bg-orange-50 text-orange-700 border-orange-200", accent: "border-l-orange-500", dot: "bg-orange-500",
    description: "Classiche, youngtimer e aste: valori, restauri e tendenze." },
  { slug: "monete", name: "Monete & Numismatica", short: "Monete", hex: "#CA8A04",
    badge: "bg-amber-50 text-amber-700 border-amber-200", accent: "border-l-amber-500", dot: "bg-amber-500",
    description: "Numismatica italiana e internazionale: conservazione, rarità e prezzi." },
  { slug: "francobolli", name: "Francobolli & Filatelia", short: "Francobolli", hex: "#0891B2",
    badge: "bg-cyan-50 text-cyan-700 border-cyan-200", accent: "border-l-cyan-500", dot: "bg-cyan-500",
    description: "Filatelia classica e moderna: varietà, cataloghi e valutazioni." },
  { slug: "fumetti", name: "Fumetti & Comics", short: "Fumetti", hex: "#7C3AED",
    badge: "bg-violet-50 text-violet-700 border-violet-200", accent: "border-l-violet-500", dot: "bg-violet-500",
    description: "Albi storici, grading e prime edizioni: il mercato del fumetto." },
  { slug: "sneakers", name: "Sneakers Edition", short: "Sneakers", hex: "#2563EB",
    badge: "bg-blue-50 text-blue-700 border-blue-200", accent: "border-l-blue-500", dot: "bg-blue-500",
    description: "Release, collaborazioni e resale: dati e consigli sulle sneakers." },
  { slug: "lego", name: "LEGO & Giocattoli", short: "LEGO", hex: "#DB2777",
    badge: "bg-pink-50 text-pink-700 border-pink-200", accent: "border-l-pink-500", dot: "bg-pink-500",
    description: "Set da collezione, sigillati e giocattoli vintage: valori nel tempo." },
  { slug: "arte", name: "Arte & Antiquariato", short: "Arte", hex: "#0D9488",
    badge: "bg-teal-50 text-teal-700 border-teal-200", accent: "border-l-teal-500", dot: "bg-teal-500",
    description: "Opere, stampe e antiquariato: aste, autenticità e mercato." },
  { slug: "memorabilia-sportivi", name: "Memorabilia Sportiva", short: "Sport", hex: "#4F46E5",
    badge: "bg-indigo-50 text-indigo-700 border-indigo-200", accent: "border-l-indigo-500", dot: "bg-indigo-500",
    description: "Maglie, cimeli e autografi: provenienza, certificazioni e valori." },
];

export const CAT_MAP = CATEGORIES.reduce((acc, c) => { acc[c.slug] = c; return acc; }, {});

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}
